import { CommonService } from "./../Services/common.service";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject } from "rxjs";
import { AuthService } from "../Services/auth.service";
import { SettingService } from "../Services/setting.service";
import { CookieService } from '../Services/cookie';

@Component({
  selector: "app-settings-update-email",
  templateUrl: "./settings-update-email.component.html",
  standalone:false,
  styleUrls: ["./settings-update-email.component.scss"],
})
export class SettingsUpdateEmailComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  Email: string = "";
  oldemail: string = "";
  otp: string = "";
  EnableForChange: boolean = true;

  oldEmail: string; // Set from actual user data
EnableEmailChange: boolean = true;
isSameEmail: boolean = false;
isValidEmail: boolean = false;

  constructor(
    private location: Location,
    private _router: Router,
    public auth: AuthService,private cookieService: CookieService,
    private setting: SettingService,
    public CommonService: CommonService
  ) {}

  async ngOnInit(): Promise<void> {
    this.auth.accessToken = await this.CommonService.Get("token");
    await this.CommonService.presentLoading();
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data.response) {
        if (data.response.code) {
          if (data.response.code == 1) {
            await this.CommonService.hideLoading();
            this.Email = this.auth?.detailuser.emailId;
            this.oldemail = this.auth?.detailuser.emailId;
            this.oldEmail=data?.response?.content?.emailId
          } else {
            await this.CommonService.hideLoading();

            this.CommonService.ParseErrorAlert("", "", this._router, data);
          }
        } else {
          await this.CommonService.hideLoading();

          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      } else {
        await this.CommonService.hideLoading();
        this.CommonService.ParseErrorAlert("", "", this._router, data);
      }
    });
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  back() {
    this.location.back();
  }

  onOtpChange(e) {
    if (e.length == 4) {
      this.otp = e.toString();
    } else {
      this.otp = null;
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter") {
    }
  }




onEmailChange(value: string) {
  this.Email = value.trim();

  // Check valid email format using regex
  this.isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.Email);

  if (this.Email.length > 0) {
    if (this.Email.toLowerCase() === this.oldEmail.toLowerCase()) {
      this.EnableEmailChange = true;
      this.isSameEmail = true;
    } else if (!this.isValidEmail) {
      this.EnableEmailChange = true;
      this.isSameEmail = false;
    } else {
      this.EnableEmailChange = false;
      this.isSameEmail = false;
    }
  } else {
    this.EnableEmailChange = true;
    this.isSameEmail = false;
  }
}




  async updateEmail(num) {
    let body = {
      EmailId: this.Email,
    };
    await this.CommonService.presentLoading();
    this.setting
      .SendChangeEmailOTP(this.auth.accessToken, body)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          await this.CommonService.hideLoading();
          this.EnableForChange = true;
        //  this.showModal(num);
       
        this.cookieService.set("UpdatedEmail", JSON.stringify(this.Email),true);  
            this._router.navigateByUrl("/VerifyEmailOtp");
        } else {
          this.EnableForChange = true;
          await this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  Change(event) {
    //
    if (this.oldemail == this.Email || this.Email == "") {
      //
      this.EnableForChange = true;
    } else {
      //
      this.EnableForChange = false;
    }
  }

  // verifyEmailOtp(){
  //       this._router.navigateByUrl("/VerifyEmailOtp");
  // }
}
